import { useProductDetailContext } from "@/contexts/ProductDetailContext";
import { SeoStrategyTab } from "@/components/seo-strategy";

/**
 * AUT-223: this tab now renders SEO Strategy -- a ranked list of recommendations built
 * from the product's Content Scorecard gaps -- replacing the previous SEO Insights
 * report.
 *
 * The old report component (SeoInsightsContentV2) is intentionally left in place: it
 * still powers the public share view (PublicSeoInsightsView), which is a separate
 * surface with its own audience.
 */
export default function ProductSeoInsightsPage() {
  const { productDetail } = useProductDetailContext();

  return (
    <SeoStrategyTab
      asin={productDetail.asin}
      productId={productDetail.id}
      brandName={productDetail.brand?.name ?? ""}
    />
  );
}
